export enum ProjectArea {
  DEFAULT = "",
  GAME = "game",
  TEACHER = "teacher",
  PROVIDER = "provider",
  ROOKIE = "rookie",
  ROOKIEDAY = "rookieday"
}
